import React, { Component } from "react";
import AddMenus from "../MastersDashboard/Menus/AddMenus";
import AddMenuItems from "../MastersDashboard/MenuItems/AddMenuItems";
import AddDepartments from "../MastersDashboard/Departments/AddDepartments";
import AddLocations from "../MastersDashboard/Locations/AddLocations";
import AddSubLocations from "../MastersDashboard/SubLocations/AddSubLocations";
import AddVendor from "../MastersDashboard/Vendors/AddVendor";
import AddCategory from "../MastersDashboard/Category/AddCategory";
import AddSection from "../MastersDashboard/Section/AddSection";
import AddBasicUnit from "../MastersDashboard/BasicUnit/AddBasicUnit";
import AddTaxs from "../MastersDashboard/Taxs/AddTaxs";
import AddPrefixCode from "../MastersDashboard/PrefixCode/AddPrefixCode";
import AddProductGroup from "../MastersDashboard/ProductGroup/AddProductGroup";
// import AddOrderLocations from "../MastersDashboard/OrderLocations/AddOrderLocations";
import AddQuality from "../MastersDashboard/quality/addQuality";
// Material  Items
import AddItem from "../Material/NewMaterialRequest/AddItem";
import AddServiceItem from "../Service/NewServiceRequest/AddServiceItem";
// import ChangeItem from "../Material/DeptMaterialRequest/ChangeItem";

import ListItem from "../Material/ListItem";
import SrListItem from "../Service/ListItem";

import AddMRList from "../PurchaseIndent/NewPurchaseRequest/AddMRList";
import PIAddItem from "../PurchaseIndent/NewPurchaseRequest/PIAddItem";
import PIListItem from "../PurchaseIndent/PIListItem";
import RFListItem from "../RequestForQuotation/RFListItem";
import SRPIAddItem from "../SRPurchaseIndent/NewSRPurchaseRequest/SRPIAddItem";
import SRPIListItem from "../SRPurchaseIndent/SRPIListItem";
import AddSRVendorModel from "../SRRequestForQuotation/AddSRVendorModel";
import SRRFListItem from "../SRRequestForQuotation/SRRFListItem";
import ProductHistory from "../Service/ProductHistory";

class AllModels extends Component {
	// constructor(props) {
	//   super(props);
	// }
	render() {
		return (
			<React.Fragment>
				<AddMenus />
				<AddMenuItems />
				<AddDepartments />
				<AddLocations />
				<AddSubLocations />
				{/* <AddOrderLocations /> */}
				<AddVendor />
				<AddSRVendorModel />
				<AddCategory />
				<AddSection />
				<AddBasicUnit />
				<AddTaxs />
				<AddPrefixCode />
				<AddProductGroup />

				<AddItem />
				<AddServiceItem />
				{/* <ChangeItem /> */}
				<ListItem />
				<SrListItem />

				<AddMRList />
				<PIAddItem />
				<SRPIAddItem />
				<SRPIListItem />
				<PIListItem />
				<ProductHistory />

				<RFListItem />
				<SRRFListItem />
				<AddQuality />
			</React.Fragment>
		);
	}
}

export default AllModels;
